<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <!-- <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button> -->
                </div>
                <div class="pl-0 pr-0 col-md-12 forms-block">
                    <div class="pl-0 col-md-6 col-sm-12 forms-block pr-0 pull-left">
                        <div class="mt-2 pull-left pr-0 pl-0 col-3 paddingleft0">
                            <div class="form-label">Request Options :</div>
                        </div>
                        <div class="pull-right pr-0 pl-0 col-9 paddingleft0">
                            <template v-if="edit_id == 0">
                                <v-select v-model="requestType" name="requestType"
                                    label="text"
                                    :options="requestTypeArr" :clearable=false>
                                </v-select>
                            </template>
                            <template v-else>
                                <v-select v-model="requestType" name="requestType" :disabled="true"
                                    label="text"
                                    :options="requestTypeArr" :clearable=false>
                                </v-select>
                            </template>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 pl-0 pr-0 forms-block pull-right">
                        <div class="page-title-container">
                            <div class="pagebutton">
                                <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Forms-->
                <form>
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!-- First Name -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">First Name :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <span class="form-control"> {{firstName}} </span>
                                        </template>
                                        <template v-else>
                                            <input @input="firstNameError = ''" type="text" maxlength="190" class="form-control" v-model="firstName" id="firstName" placeholder="Enter First Name" name="firstName">
                                            <div class="help is-danger">{{firstNameError}}</div>
                                            <div class="requiredstar">*</div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- Last Name -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">Last Name :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <span class="form-control"> {{lastName}} </span>
                                        </template>
                                        <template v-else>
                                            <input @input="lastNameError = ''" type="text" maxlength="190" class="form-control" v-model="lastName" id="lastName" placeholder="Enter Last Name" name="lastName">
                                            <div class="help is-danger">{{lastNameError}}</div>
                                            <div class="requiredstar">*</div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- Middle Name -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">Middle Name :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <span class="form-control"> {{middleName}} </span>
                                        </template>
                                        <template v-else>
                                            <input type="text" maxlength="190" class="form-control" v-model="middleName" id="middleName" placeholder="Enter Middle Name" name="middleName">
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- Birth Date -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">Birth Date :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <span class="form-control"> {{birthDate}} </span>
                                        </template>
                                        <template v-else>
                                            <date-picker @input="birthDateError = ''" placeholder="MM/DD/YYYY" id="birthDate" name="birthDate" v-model="birthDate" :config="options" aria-describedby="basic-addon1"></date-picker>
                                            <div class="help is-danger">{{birthDateError}}</div>
                                            <!-- <div class="requiredstar">*</div> -->
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- DTNA Connect ID -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">DTNA Connect ID :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <span class="form-control"> {{dtnaConnectId}} </span>
                                        </template>
                                        <template v-else>
                                            <input @input="dtnaConnectIdError = ''" type="text" maxlength="190" class="form-control" v-model="dtnaConnectId" id="middleName" placeholder="Enter DTNA Connect ID" name="dtnaConnectId">
                                            <div class="help is-danger">{{dtnaConnectIdError}}</div>
                                            <!-- <div class="requiredstar">*</div> -->
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- Employee # -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">Employee # :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <span class="form-control"> {{employeeNo}} </span>
                                        </template>
                                        <template v-else>
                                            <input @input="employeeNoError = ''" type="text" maxlength="190" class="form-control" v-model="employeeNo" id="employeeNo" placeholder="Enter Employee #" name="employeeNo">
                                            <div class="help is-danger">{{employeeNoError}}</div>
                                            <div class="requiredstar">*</div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <template v-if="isRequestType == 1">
                                <!-- Shirt Size -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">Shirt Size :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <template v-if="shirtSize == ''">
                                                    <input @input="shirtSizeError = ''" type="text" maxlength="190" class="form-control" v-model="shirtSize" id="shirtSize" placeholder="Enter Shirt Size" name="shirtSize">
                                                    <div class="help is-danger">{{shirtSizeError}}</div>
                                                    <div class="requiredstar">*</div>
                                                </template>
                                                <template v-else>
                                                    <span class="form-control"> {{shirtSize}} </span>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <input @input="shirtSizeError = ''" type="text" maxlength="190" class="form-control" v-model="shirtSize" id="shirtSize" placeholder="Enter Shirt Size" name="shirtSize">
                                                <div class="help is-danger">{{shirtSizeError}}</div>
                                                <div class="requiredstar">*</div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <!-- Company Email -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">Company Email :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <span class="form-control"> {{companyEmail}} </span>
                                        </template>
                                        <template v-else>
                                            <input @input="companyEmailError = ''" type="text" maxlength="190" class="form-control" v-model="companyEmail" id="companyEmail" placeholder="Enter Company Email" name="companyEmail">
                                            <div class="help is-danger">{{companyEmailError}}</div>
                                            <div class="requiredstar">*</div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- Location -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">Location :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <template v-if="locationId == null || !locationId.value">
                                                <v-select v-model="locationId" name="location"
                                                    label="text" @input="locationIdError = ''"
                                                    :options="locationIdArr" :clearable=false>
                                                </v-select>
                                            </template>
                                            <template v-else>
                                                <span class="form-control"> {{locationId.text}} </span>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <v-select v-model="locationId" name="location"
                                                label="text" @input="locationIdError = ''"
                                                :options="locationIdArr" :clearable=false>
                                            </v-select>
                                        </template>
                                        <div class="help is-danger">{{locationIdError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                            </div>
                            <!-- Position -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">Position :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <span class="form-control"> {{position.text}} </span>
                                        </template>
                                        <template v-else>
                                            <v-select v-model="position" name="position"
                                                label="text" @input="positionError = ''"
                                                :options="positionArr" :clearable=false>
                                            </v-select>
                                        </template>
                                        <div class="help is-danger">{{positionError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <!-- Other -->
                            <div class="col-md-6 forms-block">
                                <div class="row">
                                    <div class="col-md-3 paddingleft0">
                                        <div class="form-label">Other :</div>
                                    </div>
                                    <div class="col-md-9 paddingleft0">
                                        <template v-if="isDisable">
                                            <span class="form-control"> {{other}} </span>
                                        </template>
                                        <template v-else>
                                            <input type="text" maxlength="190" class="form-control" v-model="other" id="other" placeholder="" name="other">
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>

                            <template v-if="isRequestType == 1">
                                <div class="col-md-12 forms-block">
                                    Do you need access for and have you ever had any of the following :
                                </div>
                                <!-- arcAccout -->
                                <div class="col-md-12 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="arcAccout" id="arcAccout" name="arcAccout">
                                    <label for="arcAccout">
                                        ARC Account (Finish First, Get Ahead, worked at a dealership distributor)
                                    </label>
                                </div>
                                <div class="clearfix"></div>
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">School / Company Name :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{schooleCompanyName}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isARCAccout" maxlength="190" class="form-control" v-model="schooleCompanyName" id="schooleCompanyName" placeholder="" name="schooleCompanyName">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <!-- What Date -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">What dates :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{whatDate}} </span>
                                            </template>
                                            <template v-else>
                                                <date-picker :disabled="isARCAccout" placeholder="MM/DD/YYYY" id="whatDate" name="whatDate" v-model="whatDate" :config="options" aria-describedby="basic-addon1"></date-picker>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <!-- Your ARC ID #: -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">Your ARC ID # :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{arcId}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isARCAccout" maxlength="190" class="form-control" v-model="arcId" id="arcId" placeholder="" name="arcId">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>

                                <div class="col-md-12 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="cumminsTrainingLogin" id="cumminsTrainingLogin" name="cumminsTrainingLogin">
                                    <label for="cumminsTrainingLogin">
                                        Cummins Training / Login
                                    </label>
                                </div>
                                <div class="clearfix"></div>

                                <!-- If yes where and when -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">If yes where and when :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{ifYesWhereAndWhen}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isCumminsTrainingLogin" maxlength="190" class="form-control" v-model="ifYesWhereAndWhen" id="ifYesWhereAndWhen" name="ifYesWhereAndWhen">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <!-- Your Promo ID: -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">Your Promo ID :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{promoId}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isCumminsTrainingLogin" maxlength="190" class="form-control" v-model="promoId" id="promoId" name="promoId">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <!-- What access did you have: -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">What access did you have :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{accessYou}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isCumminsTrainingLogin" maxlength="190" class="form-control" v-model="accessYou" id="accessYou" name="accessYou">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>

                                <div class="col-md-12 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="allisonTrainingElearnHUB" id="allisonTrainingElearnHUB" name="allisonTrainingElearnHUB">
                                    <label for="allisonTrainingElearnHUB">
                                        Allison Training / Elearn / HUB access
                                    </label>
                                </div>
                                <div class="clearfix"></div>
                                <!-- If yes where and when -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">If yes where and when :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{ifYesWhereAndWhenHUB}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isAllisonTrainingElearnHUB" maxlength="190" class="form-control" v-model="ifYesWhereAndWhenHUB" id="ifYesWhereAndWhenHUB" name="ifYesWhereAndWhenHUB">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <!-- Your Elearn ID -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">Your Elearn ID :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{elearnId}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isAllisonTrainingElearnHUB" maxlength="190" class="form-control" v-model="elearnId" id="elearnId" name="elearnId">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <!-- HUB ID # -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">HUB ID # :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{hubId}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isAllisonTrainingElearnHUB" maxlength="190" class="form-control" v-model="hubId" id="hubId" name="hubId">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>

                                <div class="col-md-12 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="catTraining" id="catTraining" name="catTraining">
                                    <label for="catTraining">
                                        CAT Training / Login
                                    </label>
                                </div>
                                <div class="clearfix"></div>
                                <!-- If yes where and when -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">If yes where and when :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{ifYesWhereAndWhenCAT}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isCATTraining" maxlength="190" class="form-control" v-model="ifYesWhereAndWhenCAT" id="ifYesWhereAndWhenCAT" name="ifYesWhereAndWhenCAT">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <!-- Login ID -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">Login ID :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{loginId}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isCATTraining" maxlength="190" class="form-control" v-model="loginId" id="loginId" name="loginId">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>

                                <div class="col-md-12 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="autoCarTraining" id="autoCarTraining" name="autoCarTraining">
                                    <label for="autoCarTraining">
                                        AutoCar Training / Login
                                    </label>
                                </div>
                                <div class="clearfix"></div>
                                <!-- If yes where and when -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">If yes where and when :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{ifYesWhereAndWhenAutoCar}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isAutoCarTraining" maxlength="190" class="form-control" v-model="ifYesWhereAndWhenAutoCar" id="ifYesWhereAndWhenAutoCar" name="ifYesWhereAndWhenAutoCar">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <!-- Username -->
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">Username :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{username}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isAutoCarTraining" maxlength="190" class="form-control" v-model="username" id="username" name="username">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>

                                <div class="col-md-6 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="eatonCheck" id="eatonCheck" name="eatonCheck">
                                    <label for="eatonCheck">
                                        Eaton
                                    </label>
                                </div>
                                <!-- Meritor -->
                                <div class="col-md-6 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="meritorCheck" id="meritorCheck" name="meritorCheck">
                                    <label for="meritorCheck">
                                        Meritor
                                    </label>
                                </div>
                                <div class="clearfix"></div>

                                <div class="col-md-12 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="otherOnboarding1" id="otherOnboarding1" name="otherOnboarding1">  
                                            <label for="otherOnboarding1">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherOnboardingText1}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherOnboarding1" maxlength="190" class="form-control" v-model="otherOnboardingText1" id="otherOnboardingText1" name="otherOnboardingText1">
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="otherOnboarding2" id="otherOnboarding2" name="otherOnboarding2">
                                            <label for="otherOnboarding2">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherOnboardingText2}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherOnboarding2" maxlength="190" class="form-control" v-model="otherOnboardingText2" id="otherOnboardingText2" name="otherOnboardingText2">
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="otherOnboarding3" id="otherOnboarding3" name="otherOnboarding3">
                                            <label for="otherOnboarding3">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherOnboardingText3}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherOnboarding3" maxlength="190" class="form-control" v-model="otherOnboardingText3" id="otherOnboardingText3" name="otherOnboardingText3">
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="otherOnboarding4" id="otherOnboarding4" name="otherOnboarding4">
                                            <label for="otherOnboarding4">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherOnboardingText4}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherOnboarding4" maxlength="190" class="form-control" v-model="otherOnboardingText4" id="otherOnboardingText4" name="otherOnboardingText4">
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="otherOnboarding5" id="otherOnboarding5" name="otherOnboarding5">
                                            <label for="otherOnboarding5">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherOnboardingText5}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherOnboarding5" maxlength="190" class="form-control" v-model="otherOnboardingText5" id="otherOnboardingText5" name="otherOnboardingText5">
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="otherOnboarding6" id="otherOnboarding6" name="otherOnboarding6">
                                            <label for="otherOnboarding6">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherOnboardingText6}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherOnboarding6" maxlength="190" class="form-control" v-model="otherOnboardingText6" id="otherOnboardingText6" name="otherOnboardingText6">
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="otherOnboarding7" id="otherOnboarding7" name="otherOnboarding7">
                                            <label for="otherOnboarding7">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherOnboardingText7}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherOnboarding7" maxlength="190" class="form-control" v-model="otherOnboardingText7" id="otherOnboardingText7" name="otherOnboardingText7">
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="otherOnboarding8" id="otherOnboarding8" name="otherOnboarding8">
                                            <label for="otherOnboarding8">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherOnboardingText8}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherOnboarding8" maxlength="190" class="form-control" v-model="otherOnboardingText8" id="otherOnboardingText8" name="otherOnboardingText8">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 forms-block">
                                    &nbsp;
                                </div>
                            </template>
                            <template v-else-if="isRequestType == 2">
                                <div class="col-12 forms-block">
                                    Requested Password Reset: * DTNA Password is reset by IT *
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="arcCheck" id="arcCheck" name="arcCheck">
                                    <label for="arcCheck">
                                        ARC
                                    </label>
                                </div>
                                <div class="col-md-6 forms-block">  
                                    <input type="checkbox" :disabled="isDisable" v-model="cumminsCheck" id="cumminsCheck" name="cumminsCheck">
                                    <label for="cumminsCheck">
                                        Cummins
                                    </label>
                                    <template v-if="cumminsCheck">
                                        <div class="form-row pl-3">
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumQuickserve" id="cumQuickserve" name="cumQuickserve">
                                                <label for="cumQuickserve">
                                                    Quickserve
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumGuidanz" id="cumGuidanz" name="cumGuidanz">
                                                <label for="cumGuidanz">
                                                    Guidanz
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumCST" id="cumCST" name="cumCST">
                                                <label for="cumCST">
                                                    CST (Online Training)
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumRapidserve" id="cumRapidserve" name="cumRapidserve">
                                                <label for="cumRapidserve">
                                                    Rapidserve (Warranty)
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumWWSPS" id="cumWWSPS" name="cumWWSPS">
                                                <label for="cumWWSPS">
                                                    WWSPS
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumCumpas" id="cumCumpas" name="cumCumpas">
                                                <label for="cumCumpas">
                                                    Cumpas
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="allisonCheck" id="allisonCheck" name="allisonCheck">
                                    <label for="allisonCheck">
                                        Allison
                                    </label>
                                    <template v-if="allisonCheck">
                                        <div class="form-row pl-3">
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="allisonELearn" id="allisonELearn" name="allisonELearn">
                                                <label for="allisonELearn">
                                                    E-Learn (Online Training)
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="allisonExtranet" id="allisonExtranet" name="allisonExtranet">
                                                <label for="allisonExtranet">
                                                    Extranet/Hub
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="allisonAware" id="allisonAware" name="allisonAware">
                                                <label for="allisonAware">
                                                    Aware (Warranty)
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="catCheck" id="catCheck" name="catCheck">
                                    <label for="catCheck">
                                        CAT
                                    </label>
                                    <template v-if="catCheck">
                                        <div class="form-row pl-3">
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="catParts" id="catParts" name="catParts">
                                                <label for="catParts">
                                                    Parts
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="catCWS" id="catCWS" name="catCWS">
                                                <label for="catCWS">
                                                    CWS (Service)
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="catSIS" id="catSIS" name="catSIS">
                                                <label for="catSIS">
                                                    SIS
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="autoCarCheck" id="autoCarCheck" name="autoCarCheck">
                                    <label for="autoCarCheck">
                                        AutoCar
                                    </label>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="eatonCheckPass" id="eatonCheckPass" name="eatonCheckPass">
                                    <label for="eatonCheckPass">
                                        Eaton
                                    </label>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="meritorCheckPass" id="meritorCheckPass" name="meritorCheckPass">
                                    <label for="meritorCheckPass">
                                        Meritor
                                    </label>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input type="checkbox" :disabled="isDisable" v-model="fordCheck" id="fordCheck" name="fordCheck">
                                    <label for="fordCheck">
                                        Ford
                                    </label>
                                </div>
                                <div class="clearfix"></div>
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="otherCheckPass" id="otherCheckPass" name="otherCheckPass">
                                            <label for="otherCheckPass">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherTextPass}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherCheckPass" maxlength="190" class="form-control" v-model="otherTextPass" id="otherTextPass" placeholder="" name="otherTextPass">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    Course Unlocking:
                                </div>
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input type="checkbox" :disabled="isDisable" v-model="courseCheck" id="courseCheck" name="courseCheck">
                                            <label for="courseCheck">
                                                Course :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{courseTextPass}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isCourseCheck" maxlength="190" class="form-control" v-model="courseTextPass" id="courseTextPass" placeholder="" name="courseTextPass">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>

                                <!-- Reason -->
                                <div class="col-md-12 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">Reason :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <textarea :disabled="isDisable" class="form-control" v-model="reason" id="reason" name="reason"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-md-12 forms-block">
                                    Access being requested :
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="g2Check" id="g2Check" name="g2Check">
                                    <label for="g2Check">
                                        G2
                                    </label>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="cumminsCheckUpdate" id="cumminsCheckUpdate" name="cumminsCheckUpdate">
                                    <label for="cumminsCheckUpdate">
                                        Cummins
                                    </label>
                                    <template v-if="cumminsCheckUpdate">
                                        <div class="form-row pl-3">
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumQuickserveAcc" id="cumQuickserveAcc" name="cumQuickserveAcc">
                                                <label for="cumQuickserveAcc">
                                                    Quickserve
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumGuidanzAcc" id="cumGuidanzAcc" name="cumGuidanzAcc">
                                                <label for="cumGuidanzAcc">
                                                    Guidanz
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumCSTAcc" id="cumCSTAcc" name="cumCSTAcc">
                                                <label for="cumCSTAcc">
                                                    CST (Online Training)
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumRapidserveAcc" id="cumRapidserveAcc" name="cumRapidserveAcc">
                                                <label for="cumRapidserveAcc">
                                                    Rapidserve (Warranty)
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumWWSPSAcc" id="cumWWSPSAcc" name="cumWWSPSAcc">
                                                <label for="cumWWSPSAcc">
                                                    WWSPS
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="cumCumpasAcc" id="cumCumpasAcc" name="cumCumpasAcc">
                                                <label for="cumCumpasAcc">
                                                    Cumpas
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="allisonUpdate" id="allisonUpdate" name="allisonUpdate">
                                    <label for="allisonUpdate">
                                        Allison
                                    </label>
                                    <template v-if="allisonUpdate">
                                        <div class="form-row pl-3">
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="allisonELearnAcc" id="allisonELearnAcc" name="allisonELearnAcc">
                                                <label for="allisonELearnAcc">
                                                    E-Learn (Online Training)
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="allisonExtranetAcc" id="allisonExtranetAcc" name="allisonExtranetAcc">
                                                <label for="allisonExtranetAcc">
                                                    Extranet/Hub
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="allisonAwareAcc" id="allisonAwareAcc" name="allisonAwareAcc">
                                                <label for="allisonAwareAcc">
                                                    Aware (Warranty)
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="catUpdate" id="catUpdate" name="catUpdate">
                                    <label for="catUpdate">
                                        CAT
                                    </label>
                                    <template v-if="catUpdate">
                                        <div class="form-row pl-3">
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="catPartsAcc" id="catPartsAcc" name="catPartsAcc">
                                                <label for="catPartsAcc">
                                                    Parts
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="catCWSAcc" id="catCWSAcc" name="catCWSAcc">
                                                <label for="catCWSAcc">
                                                    CWS (Service)
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <input type="checkbox" v-model="catSISAcc" id="catSISAcc" name="catSISAcc">
                                                <label for="catSISAcc">
                                                    SIS
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="autoCarUpdate" id="autoCarUpdate" name="autoCarUpdate">
                                    <label for="autoCarUpdate">
                                        AutoCar
                                    </label>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="eatonUpdate" id="eatonUpdate" name="eatonUpdate">
                                    <label for="eatonUpdate">
                                        Eaton
                                    </label>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="meritorCheckUpdate" id="meritorCheckUpdate" name="meritorCheckUpdate">
                                    <label for="meritorCheckUpdate">
                                        Meritor
                                    </label>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <input :disabled="isDisable" type="checkbox" v-model="fordCheckUpdate" id="fordCheckUpdate" name="fordCheckUpdate">
                                    <label for="fordCheckUpdate">
                                        Ford
                                    </label>
                                </div>
                                <div class="clearfix"></div>
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input :disabled="isDisable" type="checkbox" v-model="otherCheckUpdate1" id="otherCheckUpdate1" name="otherCheckUpdate1">
                                            <label for="otherCheckUpdate1">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherTextUpdate1}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherCheckUpdate1" maxlength="190" class="form-control" v-model="otherTextUpdate1" id="otherTextUpdate1" name="otherTextUpdate1">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input :disabled="isDisable" type="checkbox" v-model="otherCheckUpdate2" id="otherCheckUpdate2" name="otherCheckUpdate2">
                                            <label for="otherCheckUpdate2">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherTextUpdate2}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherCheckUpdate2" maxlength="190" class="form-control" v-model="otherTextUpdate2" id="otherTextUpdate2" name="otherTextUpdate2">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input :disabled="isDisable" type="checkbox" v-model="otherCheckUpdate3" id="otherCheckUpdate3" name="otherCheckUpdate3">
                                            <label for="otherCheckUpdate3">
                                                Other :
                                            </label>
                                        </div>
                                        <div class="col-md-9">
                                            <template v-if="isDisable">
                                                <span class="form-control"> {{otherTextUpdate2}} </span>
                                            </template>
                                            <template v-else>
                                                <input type="text" :disabled="isOtherCheckUpdate3" maxlength="190" class="form-control" v-model="otherTextUpdate3" id="otherTextUpdate3" name="otherTextUpdate3">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 forms-block">
                                    &nbsp;
                                </div>
                            </template>

                            <template v-if="loginUserRoleId == 1 || loginUserRoleId == 2">
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">Status :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <v-select v-model="status" name="status"
                                                label="text"
                                                :options="statusArr" :clearable=false>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="loginUserRoleId == 1 && edit_id == 0">
                                <div class="col-md-6 forms-block">
                                    <div class="row">
                                        <div class="col-md-3 paddingleft0">
                                            <div class="form-label">Comment :</div>
                                        </div>
                                        <div class="col-md-9 paddingleft0">
                                            <textarea name="comment" id="comment" v-model="comment" class="form-control"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="loginUserRoleId == 1 && edit_id != 0">
                                <div class="col-md-12">
                                    <hr>
                                </div>
                                <div class="col-md-12 forms-block">
                                    <div class="form-label">Comment :</div>
                                    <div class="">
                                        <textarea name="comment" id="comment" v-model="comment" class="form-control"></textarea>
                                        <div class="help is-danger">{{commentError}}</div>
                                    </div>
                                    <button type="submit" class="mt-3 btn btn-primary themebutton" style="float: left" v-on:click.prevent="addTrainingRequestComment()">
                                        <span id="createAttachment">Save</span>
                                    </button>
                                </div>
                                <template v-if="commentArr && commentArr.length > 0">
                                    <div class="col-md-12">
                                        <h5 class="mb-4">Comment List: </h5>
                                        <template v-for="(comm, index) in commentArr">
                                            <div class="mb-4" :key="index">
                                                <div class="username-letter text-center">{{comm['imgString']}}</div>
                                                <div class="comment-details" style="display: inline-block; margin-left: 10px;">
                                                    <p class="mb-0 user-name" style="color: #098de1; font-family: 'SanFranciscoDisplayMedium';">
                                                        {{comm['name']}}
                                                    </p>
                                                    <p class="mb-0 comment-date" style="font-size: 14px; color: #8b8b8b;">
                                                        {{comm['date']}}
                                                    </p>
                                                    <p class="mb-0">
                                                        {{comm['comment']}}
                                                    </p>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </template>

                            <div class="clearfix"></div>
                            <div class="mr-17 pb-12 float-l">
                                <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                                <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addTrainingRequest('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                                <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addTrainingRequest('save')"><span id="createAttachment">Save</span></button>
                            </div>
                        </div>
                    </div>
                </form>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddTrainingRequest',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add Training Request',
                edit_id: 0,
                isRequestType: 1,
                requestType: "",
                requestTypeArr: [
                    {
                        text: "Onboarding",
                        value: "Onboarding",
                    },
                    {
                        text: "Password Reset/Course Unlock",
                        value: "Password Reset/Course Unlock",
                    },
                    {
                        text: "Additional Access/Training Request",
                        value: "Additional Access/Training Request",
                    },
                ],
                options: {
                    format: 'MM/DD/YYYY',
                    // maxDate: new Date(),
                },
                firstName: "",
                lastName: "",
                middleName: "",
                birthDate: "",
                dtnaConnectId: "",
                shirtSize: "",
                employeeNo: "",
                companyEmail: "",
                locationId: "",
                locationIdArr: [],
                locationIdError: "",
                position: "",
                positionArr: [
                    {
                        text: "Apprentice",
                        value: "Apprentice"
                    },
                    {
                        text: "Body Shop Manager",
                        value: "Body Shop Manager"
                    },
                    {
                        text: "Body Technician",
                        value: "Body Technician"
                    },
                    {
                        text: "Parts Inside Sales",
                        value: "Parts Inside Sales"
                    },
                    {
                        text: "Parts Manager",
                        value: "Parts Manager"
                    },
                    {
                        text: "Parts Outside Sales",
                        value: "Parts Outside Sales"
                    },
                    {
                        text: "Parts Support",
                        value: "Parts Support"
                    },
                    {
                        text: "Sales Manager",
                        value: "Sales Manager"
                    },
                    {
                        text: "Sales Admin",
                        value: "Sales Admin"
                    },
                    {
                        text: "Service Advisor",
                        value: "Service Advisor"
                    },
                    {
                        text: "Service Manager",
                        value: "Service Manager"
                    },
                    {
                        text: "Sales New Trucks",
                        value: "Sales New Trucks"
                    },
                    {
                        text: "Shop Foreman",
                        value: "Shop Foreman"
                    },
                    {
                        text: "Support Staff (Service)",
                        value: "Support Staff (Service)"
                    },
                    {
                        text: "Sales Used Trucks",
                        value: "Sales Used Trucks"
                    },
                    {
                        text: "Technician",
                        value: "Technician"
                    },
                    {
                        text: "Warranty Admin",
                        value: "Warranty Admin"
                    },
                    {
                        text: "Warranty Manager",
                        value: "Warranty Manager"
                    },
                    {
                        text: "Warehouse Staff",
                        value: "Warehouse Staff"
                    },
                ],
                other: "",
                status: "",
                statusArr: [
                    {
                        text: 'Close',
                        value: 'close'
                    },
                    {
                        text: 'Open',
                        value: 'open'
                    },
                    {
                        text: 'Work In Progress',
                        value: 'work_in_progress'
                    },
                ],
                comment: "",
                commentArr: [],
                commentError: "",

                // Type 1
                arcAccout: 0,
                isARCAccout: true,
                schooleCompanyName: "",
                whatDate: "",
                arcId: "",
                
                cumminsTrainingLogin: 0,
                isCumminsTrainingLogin: true,
                ifYesWhereAndWhen: "",
                promoId: "",
                accessYou: "",
                // Group of Cummins Checkbox
                cumQuickserve: 0,
                cumGuidanz: 0,
                cumCST: 0,
                cumRapidserve: 0,
                cumWWSPS: 0,
                cumCumpas: 0,

                allisonTrainingElearnHUB: 0,
                isAllisonTrainingElearnHUB: true,
                ifYesWhereAndWhenHUB: "",
                elearnId: "",
                hubId: "",
                // Group of Allison Checkbox
                allisonELearn: 0,
                allisonExtranet: 0,
                allisonAware: 0,

                catTraining: 0,
                isCATTraining: true,
                ifYesWhereAndWhenCAT: "",
                loginId: "",
                // Group of CAT Checkbox
                catParts: 0,
                catCWS: 0,
                catSIS: 0,

                autoCarTraining: 0,
                isAutoCarTraining: true,
                ifYesWhereAndWhenAutoCar: "",
                username: "",
                eatonCheck: 0,
                meritorCheck: 0,
                otherOnboarding1: 0,
                isOtherOnboarding1: true,
                otherOnboardingText1: "",

                otherOnboarding2: 0,
                isOtherOnboarding2: true,
                otherOnboardingText2: "",

                otherOnboarding3: 0,
                isOtherOnboarding3: true,
                otherOnboardingText3: "",

                otherOnboarding4: 0,
                isOtherOnboarding4: true,
                otherOnboardingText4: "",

                otherOnboarding5: 0,
                isOtherOnboarding5: true,
                otherOnboardingText5: "",

                otherOnboarding6: 0,
                isOtherOnboarding6: true,
                otherOnboardingText6: "",

                otherOnboarding7: 0,
                isOtherOnboarding7: true,
                otherOnboardingText7: "",

                otherOnboarding8: 0,
                isOtherOnboarding8: true,
                otherOnboardingText8: "",
                
                // Type 2
                arcCheck: 0,
                cumminsCheck: 0,
                allisonCheck: 0,
                catCheck: 0,
                autoCarCheck: 0,
                eatonCheckPass: 0,
                meritorCheckPass: 0,
                fordCheck: 0,
                otherCheckPass: 0,
                isOtherCheckPass: true,
                otherTextPass: "",
                courseCheck: 0,
                isCourseCheck: true,
                courseTextPass: "",
                reason: "",

                // Type 3
                g2Check: 0,
                cumminsCheckUpdate: 0,
                // Group of Cummins Checkbox for Additional Acces/Training Request
                cumQuickserveAcc: 0,
                cumGuidanzAcc: 0,
                cumCSTAcc: 0,
                cumRapidserveAcc: 0,
                cumWWSPSAcc: 0,
                cumCumpasAcc: 0,

                allisonUpdate: 0,
                // Group of Allison Checkbox for Additional Acces/Training Request
                allisonELearnAcc: 0,
                allisonExtranetAcc: 0,
                allisonAwareAcc: 0,

                catUpdate: 0,
                // Group of CAT Checkbox for Additional Acces/Training Request
                catPartsAcc: 0,
                catCWSAcc: 0,
                catSISAcc: 0,

                autoCarUpdate: 0,
                eatonUpdate: 0,
                meritorCheckUpdate: 0,
                fordCheckUpdate: 0,
                otherCheckUpdate1: 0,
                isOtherCheckUpdate1: true,
                otherTextUpdate1: "",
                otherCheckUpdate2: 0,
                isOtherCheckUpdate2: true,
                otherTextUpdate2: "",
                otherCheckUpdate3: 0,
                isOtherCheckUpdate3: true,
                otherTextUpdate3: "",

                firstNameError: "",
                lastNameError: "",
                birthDateError: "",
                dtnaConnectIdError: "",
                employeeNoError: "",
                shirtSizeError: "",
                companyEmailError: "",
                positionError: "",

                loginUserRoleId: 1,
                isChangeStatus: true,
                isDisable: false,
                userLoginId: 0,
            }
        },
        watch: {
            requestType: function(requestType) {
                localStorage.setItem('storageRequestType', requestType.text);
                self.isRequestType = 1;
                if(requestType.text == 'Password Reset/Course Unlock') {
                    self.isRequestType = 2;
                }
                if(requestType.text == 'Additional Access/Training Request') {
                    self.isRequestType = 3;
                }
            },
            arcAccout: function(arcAccout) {
                self.isARCAccout = true;
                if(arcAccout) {
                    self.isARCAccout = false;
                }
            },
            cumminsTrainingLogin: function(cumminsTrainingLogin) {
                self.isCumminsTrainingLogin = true;
                if(cumminsTrainingLogin) {
                    self.isCumminsTrainingLogin = false;
                }
            },
            allisonTrainingElearnHUB: function(allisonTrainingElearnHUB) {
                self.isAllisonTrainingElearnHUB = true;
                if(allisonTrainingElearnHUB) {
                    self.isAllisonTrainingElearnHUB = false;
                }
            },
            catTraining: function(catTraining) {
                self.isCATTraining = true;
                if(catTraining) {
                    self.isCATTraining = false;
                }
            },
            autoCarTraining: function(autoCarTraining) {
                self.isAutoCarTraining = true;
                if(autoCarTraining) {
                    self.isAutoCarTraining = false;
                }
            },
            otherCheckPass: function(otherCheckPass) {
                self.isOtherCheckPass = true;
                if(otherCheckPass) {
                    self.isOtherCheckPass = false;
                }
            },
            courseCheck: function(courseCheck) {
                self.isCourseCheck = true;
                if(courseCheck) {
                    self.isCourseCheck = false;
                }
            },
            otherCheckUpdate1: function(otherCheckUpdate1) {
                self.isOtherCheckUpdate1 = true;
                if(otherCheckUpdate1) {
                    self.isOtherCheckUpdate1 = false;
                }
            },
            otherCheckUpdate2: function(otherCheckUpdate2) {
                self.isOtherCheckUpdate2 = true;
                if(otherCheckUpdate2) {
                    self.isOtherCheckUpdate2 = false;
                }
            },
            otherCheckUpdate3: function(otherCheckUpdate3) {
                self.isOtherCheckUpdate3 = true;
                if(otherCheckUpdate3) {
                    self.isOtherCheckUpdate3 = false;
                }
            },

            otherOnboarding1: function(otherOnboarding1) {
                self.isOtherOnboarding1 = true;
                if(otherOnboarding1) {
                    self.isOtherOnboarding1 = false;
                }
            },
            otherOnboarding2: function(otherOnboarding2) {
                self.isOtherOnboarding2 = true;
                if(otherOnboarding2) {
                    self.isOtherOnboarding2 = false;
                }
            },
            otherOnboarding3: function(otherOnboarding3) {
                self.isOtherOnboarding3 = true;
                if(otherOnboarding3) {
                    self.isOtherOnboarding3 = false;
                }
            },
            otherOnboarding4: function(otherOnboarding4) {
                self.isOtherOnboarding4 = true;
                if(otherOnboarding4) {
                    self.isOtherOnboarding4 = false;
                }
            },
            otherOnboarding5: function(otherOnboarding5) {
                self.isOtherOnboarding5 = true;
                if(otherOnboarding5) {
                    self.isOtherOnboarding5 = false;
                }
            },
            otherOnboarding6: function(otherOnboarding6) {
                self.isOtherOnboarding6 = true;
                if(otherOnboarding6) {
                    self.isOtherOnboarding6 = false;
                }
            },
            otherOnboarding7: function(otherOnboarding7) {
                self.isOtherOnboarding7 = true;
                if(otherOnboarding7) {
                    self.isOtherOnboarding7 = false;
                }
            },
            otherOnboarding8: function(otherOnboarding8) {
                self.isOtherOnboarding8 = true;
                if(otherOnboarding8) {
                    self.isOtherOnboarding8 = false;
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("TrainingRequestForm");
            self.showLoader();
            self.getLocationData();

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
                self.userLoginId = userJson['id'];
            }
            this.$nextTick(function () {
                if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    self.edit_id = self.$route.params.id;
                    self.pageTitle = 'Edit Training Request';
                    self.getTrainingRequestById();
                    $("#addAndContinueLocationBtn").hide();
                    $("#createAttachment").html("Update");
                    self.hideLoader();
                } else {
                    self.hideLoader();
                }
            });

            var storageRequestType = localStorage.getItem('storageRequestType');
            if (storageRequestType && storageRequestType != null) {
                self.requestType = {text: storageRequestType, value: storageRequestType};
            } else {
                self.requestType = {text: "Onboarding", value: "Onboarding"};
            }
            self.isRequestType = 1;
            if(self.requestType.text == 'Password Reset/Course Unlock') {
                self.isRequestType = 2;
            }
            if(self.requestType.text == 'Additional Access/Training Request') {
                self.isRequestType = 3;
            }
        },
        methods: {
            buttonBack() {
                self.$router.push('/training/request/list');
            },
            getLocationData: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                };
                HTTP.get('/training/request/location/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.locationIdArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            getTrainingRequestById() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        id: self.edit_id,
                        isRequestType: self.isRequestType
                    }
                };
                self.showLoader();
                HTTP.get("/training/request/get", config)
                        .then(function (response) {
                            self.isChangeStatus = true;
                            self.isDisable = false;
                            if(self.userLoginId != response.data.content.created_by && (self.loginUserRoleId == 1 || self.loginUserRoleId == 2) ) {
                                self.isChangeStatus = false;
                            }
                            if(self.userLoginId != response.data.content.created_by) {
                                self.isDisable = true;
                            }
                            self.firstName = response.data.content.first_name;
                            self.middleName = response.data.content.middle_name;
                            self.lastName = response.data.content.last_name;
                            self.birthDate = response.data.content.birth_date;
                            self.dtnaConnectId = response.data.content.dtna_connect_id;
                            self.employeeNo = response.data.content.employee_no;
                            self.shirtSize = response.data.content.shirt_size;
                            self.companyEmail = response.data.content.company_email;
                            self.locationId = {text: response.data.content.location_text, value: response.data.content.location_id};
                            self.position = {text: response.data.content.position, value: response.data.content.position};
                            self.status = {text: self.formatString(response.data.content.status), value: response.data.content.status};
                            self.other = response.data.content.other;
                            // self.comment = response.data.content.comment;
                            self.commentArr = [];
                            if(response.data.content.comments && response.data.content.comments.length > 0) {
                               self.commentArr = response.data.content.comments;
                            }
                            if(self.isRequestType == 1) {
                                self.arcAccout = response.data.content.arc_account;
                                self.schooleCompanyName = response.data.content.school_company_name;
                                self.whatDate = response.data.content.what_date;
                                self.arcId = response.data.content.arc_id;
                                self.cumminsTrainingLogin = response.data.content.cummins_training_login;
                                self.ifYesWhereAndWhen = response.data.content.cummins_training_login_text;
                                self.accessYou = response.data.content.access;
                                self.promoId = response.data.content.promo_id;
                                self.allisonTrainingElearnHUB = response.data.content.allison_training_elearn_hub_access;
                                self.ifYesWhereAndWhenHUB = response.data.content.allison_training_elearn_hub_access_text;
                                self.elearnId = response.data.content.elearn_id;
                                self.hubId = response.data.content.hub_id;
                                self.catTraining = response.data.content.cat_training_login;
                                self.ifYesWhereAndWhenCAT = response.data.content.cat_training_login_text;
                                self.loginId = response.data.content.login_id;
                                self.autoCarTraining = response.data.content.autocar_training_login;
                                self.ifYesWhereAndWhenAutoCar = response.data.content.autocar_training_login_text;
                                self.username = response.data.content.username;
                                self.eatonCheck = response.data.content.eaton;
                                self.meritorCheck = response.data.content.meritor;
                                
                                self.otherOnboarding1 = response.data.content.other1;
                                self.otherOnboardingText1 = response.data.content.other1_text;
                                self.otherOnboarding2 = response.data.content.other2;
                                self.otherOnboardingText2 = response.data.content.other2_text;
                                self.otherOnboarding3 = response.data.content.other3;
                                self.otherOnboardingText3 = response.data.content.other3_text;
                                self.otherOnboarding4 = response.data.content.other4;
                                self.otherOnboardingText4 = response.data.content.other4_text;
                                self.otherOnboarding5 = response.data.content.other5;
                                self.otherOnboardingText5 = response.data.content.other5_text;
                                self.otherOnboarding6 = response.data.content.other6;
                                self.otherOnboardingText6 = response.data.content.other6_text;
                                self.otherOnboarding7 = response.data.content.other7;
                                self.otherOnboardingText7 = response.data.content.other7_text;
                                self.otherOnboarding8 = response.data.content.other8;
                                self.otherOnboardingText8 = response.data.content.other8_text;
                            } else if(self.isRequestType == 2) {
                                self.arcCheck = response.data.content.arc;

                                self.cumminsCheck = response.data.content.cummins;
                                self.cumQuickserve = response.data.content.cumQuickserve;
                                self.cumGuidanz = response.data.content.cumGuidanz;
                                self.cumCST = response.data.content.cumCST;
                                self.cumRapidserve = response.data.content.cumRapidserve;
                                self.cumWWSPS = response.data.content.cumWWSPS;
                                self.cumCumpas = response.data.content.cumCumpas;

                                self.allisonCheck = response.data.content.allison;
                                self.allisonELearn = response.data.content.allisonELearn;
                                self.allisonExtranet = response.data.content.allisonExtranet;
                                self.allisonAware = response.data.content.allisonAware;

                                self.catCheck = response.data.content.cat;
                                self.catParts = response.data.content.catParts;
                                self.catCWS = response.data.content.catCWS;
                                self.catSIS = response.data.content.catSIS;

                                self.autoCarCheck = response.data.content.autocar;
                                self.eatonCheckPass = response.data.content.eaton;
                                self.meritorCheckPass = response.data.content.meritor;
                                self.fordCheck = response.data.content.ford;
                                self.otherCheckPass = response.data.content.other;
                                self.otherTextPass = response.data.content.other_text;
                                self.courseCheck = response.data.content.course;
                                self.courseTextPass = response.data.content.course_text;
                                self.reason = response.data.content.reason;
                            } else {
                                self.g2Check = response.data.content.g2;

                                self.cumminsCheckUpdate = response.data.content.cummins;
                                self.cumQuickserveAcc = response.data.content.cumQuickserveAcc;
                                self.cumGuidanzAcc = response.data.content.cumGuidanzAcc;
                                self.cumCSTAcc = response.data.content.cumCSTAcc;
                                self.cumRapidserveAcc = response.data.content.cumRapidserveAcc;
                                self.cumWWSPSAcc = response.data.content.cumWWSPSAcc;
                                self.cumCumpasAcc = response.data.content.cumCumpasAcc;

                                self.allisonUpdate = response.data.content.allison;
                                self.allisonELearnAcc = response.data.content.allisonELearnAcc;
                                self.allisonExtranetAcc = response.data.content.allisonExtranetAcc;
                                self.allisonAwareAcc = response.data.content.allisonAwareAcc;

                                self.catUpdate = response.data.content.cat;
                                self.catPartsAcc = response.data.content.catPartsAcc;
                                self.catCWSAcc = response.data.content.catCWSAcc;
                                self.catSISAcc = response.data.content.catSISAcc;

                                self.autoCarUpdate = response.data.content.autocar;
                                self.eatonUpdate = response.data.content.eaton;
                                self.meritorCheckUpdate = response.data.content.meritor;
                                self.fordCheckUpdate = response.data.content.ford;
                                self.otherCheckUpdate1 = response.data.content.other1;
                                self.otherTextUpdate1 = response.data.content.other1_text;
                                self.otherCheckUpdate2 = response.data.content.other2;
                                self.otherTextUpdate2 = response.data.content.other2_text;
                                self.otherCheckUpdate3 = response.data.content.other3;
                                self.otherTextUpdate3 = response.data.content.other3_text;
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            checkForm: function () {
                var checked = true;
                self.firstNameError = "";
                self.lastNameError = "";
                self.birthDateError = "";
                self.dtnaConnectIdError = "";
                self.employeeNoError = "";
                self.shirtSizeError = "";
                self.companyEmailError = "";
                self.locationIdError = "";
                self.positionError = "";

                if (!self.firstName) {
                    self.firstNameError = "Please enter first name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.lastName) {
                    self.lastNameError = "Please enter last name";
                    if (checked) {
                        checked = false;
                    }
                }
                /* if (!self.birthDate) {
                    self.birthDateError = "Select Birth Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.dtnaConnectId) {
                    self.dtnaConnectIdError = "Please Enter DTNA Connect Id";
                    if (checked) {
                        checked = false;
                    }
                } */
                if (!self.employeeNo) {
                    self.employeeNoError = "Please Enter employee #";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.isRequestType == 1) {
                    if (!self.shirtSize) {
                        self.shirtSizeError = "Please enter Shirt Size";
                        if (checked) {
                            checked = false;
                        }
                    }/*  else if (self.shirtSize && !self.numberFormateValidation(self.shirtSize)) {
                        self.shirtSizeError = "Please enter numeric value";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.shirtSize && self.numberFormateValidation(self.shirtSize) && self.shirtSize > 1000) {
                        self.shirtSizeError = "Max Shirt Quantity is 1000";
                        if (checked) {
                            checked = false;
                        }
                    } */
                }
                if (!self.companyEmail) {
                    self.companyEmailError = "Please Enter company Email";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.companyEmail && !self.validEmail(self.companyEmail)) {
                    self.companyEmailError = "Please Enter Valid company Email";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.position == null || !self.position.value) {
                    self.positionError = "select position";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.locationId == null || !self.locationId.value) {
                    self.locationIdError = "select location";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addTrainingRequest(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            firstName: self.firstName,
                            lastName: self.lastName,
                            middleName: self.middleName,
                            birthDate: self.birthDate,
                            dtnaConnectId: self.dtnaConnectId,
                            employeeNo: self.employeeNo,
                            shirt_size: self.shirtSize,
                            companyEmail: self.companyEmail,
                            location_id: self.locationId.value,
                            position: self.position.text,
                            other: self.other,
                            isRequestType: self.isRequestType,
                            id: self.edit_id,
                            isChangeStatus: self.isChangeStatus ? 1 : 0,
                            status: self.status.value,
                            comment: self.comment
                        };
                        if(self.isRequestType == 1) {
                            fields.arcAccout = self.arcAccout;
                            fields.schooleCompanyName = self.schooleCompanyName;
                            fields.whatDate = self.whatDate;
                            fields.arcId = self.arcId;
                            fields.cumminsTrainingLogin = self.cumminsTrainingLogin;
                            fields.ifYesWhereAndWhen = self.ifYesWhereAndWhen;
                            fields.accessYou = self.accessYou;
                            fields.promoId = self.promoId;
                            fields.allisonTrainingElearnHUB = self.allisonTrainingElearnHUB;
                            fields.ifYesWhereAndWhenHUB = self.ifYesWhereAndWhenHUB;
                            fields.elearnId = self.elearnId;
                            fields.hubId = self.hubId;
                            fields.catTraining = self.catTraining;
                            fields.ifYesWhereAndWhenCAT = self.ifYesWhereAndWhenCAT;
                            fields.loginId = self.loginId;
                            fields.autoCarTraining = self.autoCarTraining;
                            fields.ifYesWhereAndWhenAutoCar = self.ifYesWhereAndWhenAutoCar;
                            fields.username = self.username;
                            fields.eatonCheck = self.eatonCheck;
                            fields.meritorCheck = self.meritorCheck;

                            fields.otherOnboarding1 = self.otherOnboarding1;
                            fields.otherOnboardingText1 = self.otherOnboardingText1;
                            fields.otherOnboarding2 = self.otherOnboarding2;
                            fields.otherOnboardingText2 = self.otherOnboardingText2;
                            fields.otherOnboarding3 = self.otherOnboarding3;
                            fields.otherOnboardingText3 = self.otherOnboardingText3;
                            fields.otherOnboarding4 = self.otherOnboarding4;
                            fields.otherOnboardingText4 = self.otherOnboardingText4;
                            fields.otherOnboarding5 = self.otherOnboarding5;
                            fields.otherOnboardingText5 = self.otherOnboardingText5;
                            fields.otherOnboarding6 = self.otherOnboarding6;
                            fields.otherOnboardingText6 = self.otherOnboardingText6;
                            fields.otherOnboarding7 = self.otherOnboarding7;
                            fields.otherOnboardingText7 = self.otherOnboardingText7;
                            fields.otherOnboarding8 = self.otherOnboarding8;
                            fields.otherOnboardingText8ð = self.otherOnboardingText8;
                        }
                        if(self.isRequestType == 2) {
                            fields.arcCheck = self.arcCheck;
                            fields.cumminsCheck = self.cumminsCheck;
                            if(self.cumminsCheck) {
                                fields.cumQuickserve = self.cumQuickserve;
                                fields.cumGuidanz = self.cumGuidanz;
                                fields.cumCST = self.cumCST;
                                fields.cumRapidserve = self.cumRapidserve;
                                fields.cumWWSPS = self.cumWWSPS;
                                fields.cumCumpas = self.cumCumpas;
                            }
                            fields.allisonCheck = self.allisonCheck;
                            if(self.allisonCheck) {
                                fields.allisonELearn = self.allisonELearn;
                                fields.allisonExtranet = self.allisonExtranet;
                                fields.allisonAware = self.allisonAware;
                            }
                            fields.catCheck = self.catCheck;
                            if(self.catCheck) {
                                fields.catParts = self.catParts;
                                fields.catCWS = self.catCWS;
                                fields.catSIS = self.catSIS;
                            }
                            fields.autoCarCheck = self.autoCarCheck;
                            fields.eatonCheckPass = self.eatonCheckPass;
                            fields.meritorCheckPass = self.meritorCheckPass;
                            fields.fordCheck = self.fordCheck;
                            fields.otherCheckPass = self.otherCheckPass;
                            fields.otherTextPass = self.otherTextPass;
                            fields.courseCheck = self.courseCheck;
                            fields.courseTextPass = self.courseTextPass;
                            fields.reason = self.reason;
                        }
                        if(self.isRequestType == 3) {
                            fields.g2Check = self.g2Check;
                            fields.cumminsCheckUpdate = self.cumminsCheckUpdate;
                            if(self.cumminsCheckUpdate) {
                                fields.cumQuickserveAcc = self.cumQuickserveAcc;
                                fields.cumGuidanzAcc = self.cumGuidanzAcc;
                                fields.cumCSTAcc = self.cumCSTAcc;
                                fields.cumRapidserveAcc = self.cumRapidserveAcc;
                                fields.cumWWSPSAcc = self.cumWWSPSAcc;
                                fields.cumCumpasAcc = self.cumCumpasAcc;
                            }
                            fields.allisonUpdate = self.allisonUpdate;
                            if(self.allisonUpdate) {
                                fields.allisonELearnAcc = self.allisonELearnAcc;
                                fields.allisonExtranetAcc = self.allisonExtranetAcc;
                                fields.allisonAwareAcc = self.allisonAwareAcc;
                            }
                            fields.catUpdate = self.catUpdate;
                            if(self.catUpdate) {
                                fields.catPartsAcc = self.catPartsAcc;
                                fields.catCWSAcc = self.catCWSAcc;
                                fields.catSISAcc = self.catSISAcc;
                            }
                            fields.autoCarUpdate = self.autoCarUpdate;
                            fields.eatonUpdate = self.eatonUpdate;
                            fields.meritorCheckUpdate = self.meritorCheckUpdate;
                            fields.fordCheckUpdate = self.fordCheckUpdate;
                            fields.otherCheckUpdate1 = self.otherCheckUpdate1;
                            fields.otherTextUpdate1 = self.otherTextUpdate1;
                            fields.otherCheckUpdate2 = self.otherCheckUpdate2;
                            fields.otherTextUpdate2 = self.otherTextUpdate2;
                            fields.otherCheckUpdate3 = self.otherCheckUpdate3;
                            fields.otherTextUpdate3 = self.otherTextUpdate3;
                        }
                        self.showLoader();
                        HTTP.post("/training/request/edit", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if (flag == 'save') {
                                        self.buttonBack();
                                    } else {                                        
                                        self.clearSaveAndContinue();
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            clearSaveAndContinue: function() {
                self.firstName = '';
                self.lastName = '';
                self.middleName = '';
                self.birthDate = '';
                self.dtnaConnectId = '';
                self.employeeNo = '';
                self.shirtSize = '';
                self.companyEmail = '';
                self.locationId = '';
                self.position = '';
                self.other = '';
                self.comment = '';
                if(self.isRequestType == 1) {
                    self.arcAccout = 0;
                    self.schooleCompanyName = "";
                    self.whatDate = "";
                    self.arcId = "";
                    self.cumminsTrainingLogin = 0;
                    self.ifYesWhereAndWhen = "";
                    self.accessYou = "";
                    self.promoId = "";
                    self.allisonTrainingElearnHUB = 0;
                    self.ifYesWhereAndWhenHUB = "";
                    self.elearnId = "";
                    self.hubId = "";
                    self.catTraining = 0;
                    self.ifYesWhereAndWhenCAT = "";
                    self.loginId = "";
                    self.autoCarTraining = 0;
                    self.ifYesWhereAndWhenAutoCar = "";
                    self.username = "";
                    self.eatonCheck = 0;
                    self.meritorCheck = 0;

                    self.otherOnboarding1 = 0;
                    self.otherOnboardingText1 = "";
                    self.otherOnboarding2 = 0;
                    self.otherOnboardingText2 = "";
                    self.otherOnboarding3 = 0;
                    self.otherOnboardingText3 = "";
                    self.otherOnboarding4 = 0;
                    self.otherOnboardingText4 = "";
                    self.otherOnboarding5 = 0;
                    self.otherOnboardingText5 = "";
                    self.otherOnboarding6 = 0;
                    self.otherOnboardingText6 = "";
                    self.otherOnboarding7 = 0;
                    self.otherOnboardingText7 = "";
                    self.otherOnboarding8 = 0;
                    self.otherOnboardingText8 = "";
                }
                if(self.isRequestType == 2) {
                    self.arcCheck = 0;
                    self.cumminsCheck = 0;
                    self.cumQuickserve = 0;
                    self.cumGuidanz = 0;
                    self.cumCST = 0;
                    self.cumRapidserve = 0;
                    self.cumWWSPS = 0;
                    self.cumCumpas = 0;

                    self.allisonCheck = 0;
                    self.allisonELearn = 0;
                    self.allisonExtranet = 0;
                    self.allisonAware = 0;

                    self.catCheck = 0;
                    self.catParts = 0;
                    self.catCWS = 0;
                    self.catSIS = 0;

                    self.autoCarCheck = 0;
                    self.eatonCheckPass = 0;
                    self.meritorCheckPass = 0;
                    self.fordCheck = 0;
                    self.otherCheckPass = 0;
                    self.otherTextPass = "";
                    self.courseCheck = 0;
                    self.courseTextPass = "";
                    self.reason = "";
                }
                if(self.isRequestType == 3) {
                    self.g2Check = 0;
                    self.cumminsCheckUpdate = 0;
                    self.cumQuickserveAcc = 0;
                    self.cumGuidanzAcc = 0;
                    self.cumCSTAcc = 0;
                    self.cumRapidserveAcc = 0;
                    self.cumWWSPSAcc = 0;
                    self.cumCumpasAcc = 0;

                    self.allisonUpdate = 0;
                    self.allisonELearnAcc = 0;
                    self.allisonExtranetAcc = 0;
                    self.allisonAwareAcc = 0;

                    self.catUpdate = 0;
                    self.catPartsAcc = 0;
                    self.catCWSAcc = 0;
                    self.catSISAcc = 0;

                    self.autoCarUpdate = 0;
                    self.eatonUpdate = 0;
                    self.meritorCheckUpdate = 0;
                    self.fordCheckUpdate = 0;
                    self.otherCheckUpdate1 = 0;
                    self.otherTextUpdate1 = "";
                    self.otherCheckUpdate2 = 0;
                    self.otherTextUpdate2 = "";
                    self.otherCheckUpdate3 = 0;
                    self.otherTextUpdate3 = "";
                }
            },
            addTrainingRequestComment() {
                self.commentError = "";
                if (!self.comment) {
                    self.commentError = "Please Enter Comment";
                    return false;
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                };
                var fields = {
                    trainingRequestId: self.edit_id,
                    comment: self.comment
                };
                HTTP.post("/training/request/comment", fields, config)
                    .then(function (response) {
                        if (response.data.status == "success") {
                            self.getTrainingRequestById();
                            self.comment = "";
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/Forms/TrainingRequestMaster/AddUpdateTrainingRequest.vue